export enum WIDGET_KEYS {
  CARD_STATES = 'CARD_STATES',
  PROGRESS = 'PROGRESS',
  HEATMAP = 'HEATMAP',
  QBANK_PERFORMANCE = 'QBANK_PERFORMANCE',
  TOPIC_RADAR = 'TOPIC_RADAR',
  FLASHCARD_TREND = 'FLASHCARD_TREND',
  VANITY_METRICS = 'VANITY_METRICS',
  DAYS_UNTIL_EXAM = 'DAYS_UNTIL_EXAM',
  MY_BOOKMARKS = 'MY_BOOKMARKS',
  SCHOOL_LEADERBOARD = 'SCHOOL_LEADERBOARD',
  BUZZWORDS_TILE = 'BUZZWORDS_TILE',
  DIFFERENTIAL_TILE = 'DIFFERENTIAL_TILE',
}

export interface TopicRadarData {
  [topicName: string]: {
    correct: number;
    total: number;
    percentage: number;
  };
}
